import apiHelper from '../helpers/apiHelper'

export default {
  get()
  {
    return apiHelper.request('autoinvest/strategy')
  },
  getDetails(id)
  {
    return apiHelper.request('autoinvest/strategy/' + id)
  },
  createStrategy(data)
  {
    return apiHelper.request('autoinvest/strategy', data, 'POST')
  },
  updateStrategy(strategyId, data)
  {
    return apiHelper.request('autoinvest/strategy/' + strategyId, data, 'PUT')
  },
  activateStrategy(strategyId, data)
  {
    return apiHelper.request('autoinvest/strategy/' + strategyId + '/activate', data, 'POST')
  },
  deleteStrategy(strategyId)
  {
    return apiHelper.request('autoinvest/strategy/' + strategyId, {}, 'DELETE')
  },
  getRecentJobs(strategyId)
  {
    return apiHelper.request('autoinvest/investment-log/' + strategyId)
  }
}
